// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__lLq0D","left":"Virtual_left__mUmDq","wrapper":"Virtual_wrapper__fIn1r"};